/**
 * Grid de cards de manifiestos por transportadora
 */
import React, { useMemo } from 'react'
import ManifiestoCarrierCard from './ManifiestoCarrierCard'
import ManifiestoCarrierSkeleton from './ManifiestoCarrierSkeleton'
import type {
  ManifiestoCarrierConfig,
  ManifiestoCarrierCount,
} from '../../types/manifiestos'

interface ManifiestosGridProps {
  carriers: ManifiestoCarrierConfig[]
  counts: ManifiestoCarrierCount[]
  isRefreshing: boolean
  generatingCarrierId: string | null
  onGenerate: (carrier: ManifiestoCarrierConfig) => void
}

const ManifiestosGrid: React.FC<ManifiestosGridProps> = ({
  carriers,
  counts,
  isRefreshing,
  generatingCarrierId,
  onGenerate,
}) => {
  const countById = useMemo(() => {
    const map = new Map<string, ManifiestoCarrierCount>()
    counts.forEach((item) => map.set(item.carrierId, item))
    return map
  }, [counts])

  const showSkeletons =
    isRefreshing && counts.every((item) => item.isLoading)

  if (showSkeletons) {
    return (
      <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-6">
        {carriers.map((carrier) => (
          <ManifiestoCarrierSkeleton key={carrier.id} />
        ))}
      </div>
    )
  }

  return (
    <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-6">
      {carriers.map((carrier) => {
        const data = countById.get(carrier.id)
        return (
          <ManifiestoCarrierCard
            key={carrier.id}
            carrier={carrier}
            count={data?.count ?? 0}
            isLoading={data?.isLoading ?? false}
            error={data?.error ?? null}
            isGenerating={generatingCarrierId === carrier.id}
            onGenerate={onGenerate}
          />
        )
      })}
    </div>
  )
}

export default ManifiestosGrid
